// This is very old legacy code from the Backbone days. Delete it if you can.

import * as _ from 'lodash';

const indexOf =
  [].indexOf ||
  function (item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

const QueryString = (function () {
  function _Class(queryString) {
    let pair, ref;
    this.queryString = queryString;
    // eslint-disable-next-line no-unused-expressions
    this.queryString ||
      (this.queryString =
        (ref = window.document.location.search) != null
          ? ref.substr(1)
          : void 0);
    this.pairs = [];
    this.object = {};
    if (indexOf.call(this.queryString, '=') >= 0) {
      this.variables = this.queryString.split('&');
      this.pairs = function () {
        let j, len;
        const ref1 = this.variables;
        const results = [];
        for (j = 0, len = ref1.length; j < len; j++) {
          pair = ref1[j];
          results.push(pair.split('='));
        }
        return results;
      }.call(this);
      this.pairs = _.map(this.pairs, function (p) {
        return [p[0], decodeURIComponent(p[1])];
      });
      this.object = _.fromPairs(this.pairs || []);
    }
  }

  return _Class;
})();

export default QueryString;
